import { createTheme } from './createTheme';
import type { ITheme } from './types/ITheme';

export const FluentTheme: ITheme = createTheme({});
